<div class="dialog-surface">
  <h2 mat-dialog-title>{{ title }}</h2>
  <div class="subtitle">{{ explainer }}</div>
  <div class="options">
    @for (option of options; track option) {
      <div class="option">
        <b>{{ option.name }}</b>
        <ul>
          @for (condition of option.conditions; track condition) {
            <li [className]="'condition-' + (condition.met ? 'met' : 'unmet')"
              ><span class="cdk-visually-hidden">
                @if (condition.met) {
                  Requirement met:
                } @else {
                  Requirement not met:
                }
              </span>
              {{ condition.name }}</li
            >
          }
        </ul>
      </div>
    }
  </div>
  <mat-dialog-actions>
    <button matButton="text" type="button" mat-dialog-close
      ><mat-icon class="material-symbols-outlined">close</mat-icon> Close</button
    >
  </mat-dialog-actions>
</div>
